import type { Address } from "src/services/models/Address";
import type { Appointment } from "src/services/models/Appointment";

import type { Maybe } from "./types";

export const getAddress = (appointment: Maybe<Appointment | Address>) =>
  [appointment?.line1, appointment?.line2, appointment?.town, appointment?.postcode]
    .filter(Boolean)
    .join(", ");
